import React from "react";
import PropTypes from 'prop-types';
import { Button } from "reactstrap";

import {
  callReferenceTimestamp,
  playButton,
  visibleRemoveButton,
  hiddenRemoveButton
} from "./styles/CallReferences.module.scss";

import Timestamp from "shared/react_components/Timestamp";
import IconButton from "shared/react_components/IconButton";
import Icon from "shared/react_components/MaterialIcon";

import SpeechBubble from "./SpeechBubble";

const validStartTime = value => typeof value === "number"; // 0 is falsey but is a valid start time

const CallReferences = ({ callRecordingRef, transcriptRef, onAudioJump, onRemove }) => {
  const { startTime: callStartTime } = callRecordingRef || {};
  const { startTime: transcriptStartTime, text, speaker } = transcriptRef || {};

  const startTime = validStartTime(callStartTime) ? callStartTime : transcriptStartTime;

  return (
    <div className="d-flex">
      <SpeechBubble speaker={speaker}>
        <div className="d-flex mt-1">
          {validStartTime(startTime) &&
             <Timestamp className={callReferenceTimestamp} seconds={startTime} trimLeadingZeros />}
          {validStartTime(callStartTime) &&
            <Button
              color="link"
              outline
              className={playButton}
              onClick={onAudioJump && (() => onAudioJump(callStartTime))}
              disabled={!onAudioJump}
              data-test-id="play-recording-button"
            >
              <Icon
                name="play_circle_outline"
                style={{ fontSize: "24px" }} // Force fontSize by inlining it
              />
            </Button>
          }
          {text &&
            <div className="p-1 ml-1" data-test-id="transcript-text">
              {text}
            </div>
          }
        </div>
      </SpeechBubble>
      <IconButton
        className={onRemove ? visibleRemoveButton : hiddenRemoveButton}
        icon="clear"
        onClick={onRemove}
        data-test-id="remove-references-button"
      />
    </div>
  );
};

CallReferences.propTypes = {
  callRecordingRef: PropTypes.shape({
    startTime: PropTypes.number
  }),
  transcriptRef: PropTypes.shape({
    startTime: PropTypes.number,
    text: PropTypes.string,
    speaker: PropTypes.string
  }),
  onAudioJump: PropTypes.func,
  onRemove: PropTypes.func
};

export default CallReferences;
